export default __webpack_public_path__ + "static/media/cardapioweb.6dbe2b92.png";